/*eslint-disable */
define([], function() {
    function format(discount) {
        if (discount) {
            return Math.floor(discount);
        } else {
            return null;
        }
    }

    return {
        format: format
    };
});
